import type { TransactionType } from '../types'

export const transactionSettingsKeys = {
	all: ['transaction-settings'] as const,
	depositStatus: () =>
		[...transactionSettingsKeys.all, 'deposit', 'status'] as const,
	withdrawStatus: () =>
		[...transactionSettingsKeys.all, 'withdraw', 'status'] as const,
	depositSchedules: () =>
		[...transactionSettingsKeys.all, 'deposit', 'schedules'] as const,
	withdrawSchedules: () =>
		[...transactionSettingsKeys.all, 'withdraw', 'schedules'] as const,
	schedule: (id: string) =>
		[...transactionSettingsKeys.all, 'schedule', id] as const,
	status: (type: TransactionType) =>
		type === 'deposit'
			? transactionSettingsKeys.depositStatus()
			: transactionSettingsKeys.withdrawStatus(),
	schedules: (type: TransactionType) =>
		type === 'deposit'
			? transactionSettingsKeys.depositSchedules()
			: transactionSettingsKeys.withdrawSchedules(),
}
